module.exports = __webpack_public_path__ + "assets/img/thumb-Blue-Microphones-Langing-page.7efcec69.jpg";